import isFunction from 'lodash/isFunction'
import React, { useState } from 'react'
import { useMount } from 'react-nb-hooks'
import { useDispatch } from 'react-redux'
// @ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'

const getContextMenuItemConfirmModalName = (instanceName) => `contextMenuItemConfirm-of-${instanceName}-grid`

export const ContextMenuConfirmationModal = ({ instanceName, onConfirm, message, onClose }) => {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  useMount(() => {
    dispatch(LKModalActions.openConfirmation(getContextMenuItemConfirmModalName(instanceName), { message }))
  })

  const handleConfirm = async () => {
    if (isFunction(onConfirm)) {
      setLoading(true)

      try {
        await onConfirm()
      } catch (e) {
        setLoading(false)
        dispatch(LKModalActions.openError(e.Error.Message || e.Error.Text))
      }
    }
  }

  return (
    <LKModal.Confirmation
      name={getContextMenuItemConfirmModalName(instanceName)}
      loading={loading}
      onConfirm={handleConfirm}
      onClose={onClose}
    />
  )
}
